import React from "react";
import DevLibrary from "@/components/DevLibrary";

const CFG = {
  prefix: "innovation",
  title: "Innovation Lab",
  subtitle: "Latest printing techniques, inks & effects from our R&D team",
  categories: ["Silicone", "High Density", "Puff", "Suede", "Crack Effect", "Rubber", "Gel", "Foil", "Metallic", "Reflective", "Glow in the Dark", "Discharge", "Water-Based", "CMYK", "Special Effect Ink", "Experimental Ink"],
  statuses: ["Research", "Testing", "Approved", "Buyer Ready", "Production Ready"],
};

export default function InnovationLab() {
  return <DevLibrary cfg={CFG} />;
}
